/**
 *
 * key
 *
 */

 const key = 'ZXZlbnRDbGllbnRDb21wbGV0ZQ=='

 export default key
 